import Mutations from '../../odata/mutations';

export default { ...new Mutations('userSetting'), ...new Mutations('userSettings') };
